/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Saved_Draft1Inputs */

const vi_cmspost_saved_draft1 = /** @type {(inputs: Cmspost_Saved_Draft1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu nháp. Bài trên web chưa đổi cho tới khi bấm Đăng.`)
};

/**

* @param {Cmspost_Saved_Draft1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_saved_draft1 = /** @type {((inputs?: Cmspost_Saved_Draft1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Saved_Draft1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_saved_draft1(inputs)
});
export { cmspost_saved_draft1 as "cmsPost_saved_draft" }